<div class="p-grid">
  <p-card class="p-col-6" styleClass="card-container">
    <h3>About me</h3>
    <p>
      Seasoned Technical Evangelist with 13+ years of experience in the software industry, focused on <b>JavaScript and
      Java ecosystems</b>. Proven expertise in delivering freelance solutions and mentoring developers through structured
      training, workshops, and one-on-one tutoring.
    </p>
    <h3>Professional summary</h3>
    <p>
13+ years of experience in application development across full-stack and enterprise systems using Node.js, React.js, Angular, TypeScript, and Java.    </p>
    <ul>
      <li>
        8+ experience developing JavaScript Apps. Backend (Node.js) and frontend
        (React , Angular)
      </li>
      <li>
        5+ experience on Java Application development using Java Spring , JSP, Servlets, Swing,
        Restful services, XML, PostgreSQL.
      </li>

    </ul>
    <h3>Industry Experience</h3>
    <p>
      Over the course of 13 years, I have collaborated with and contributed to several organizations, gaining diverse experience across different domains and technologies.
    </p>

    <div class="p-grid p-align-center">
      <img style="vertical-align: middle" src="assets\xoriant.png" class="p-col-2" />
      <img style="vertical-align: middle" src="assets\IBM.png" class="p-col-2" />

      <img style="vertical-align: middle" src="assets\wipro.jpg" class="p-col-2" />

      <img style="vertical-align: middle" src="assets\USTGlobal.png" class="p-col-2" />

      <img style="vertical-align: middle" src="assets\accenture.png" class="p-col-2" />

      <img style="vertical-align: middle" src="assets\ge.jpg" class="p-col-1" />

      <img style="vertical-align: middle" src="assets\Tech-mahindra.png" class="p-col-2" />

      <img style="vertical-align: middle" src="assets\Aricent-Technologies.png" class="p-col-2" />
    </div>
    <h3>Technical Experience</h3>
    I have extensive Experience in developing Web Applicatios using <b>Node.js</b> , <b>Express</b> , <b>GraphQL</b> ,
    <b>React.js</b> , <b>Angular</b>
    and also has experience in developing java application using <b>Core Java</b> and <b>Java Spring</b> , etc.
    <br />
    Worked as a <b>polyglot developer</b>, building and maintaining applications using multiple languages such as <b>React, Node.js, Java and Python</b>.<br/>
    I have experience working with <b>micro-frontend (MFE) architectures</b> for scalable frontend systems <br />
    Deployed applications on AWS, leveraging services like <b>S3 , CloudFront , ACM</b>. <br />
    Implemented CI/CD pipelines using AWS services to automate build and deployment processes.<br />
    I have experience in following areas

    <ul>
      <li>
        Experience in Node.js Full stack development (Node.js, Angular
        (v2,v4,v6) ,React.js, GraphQL) of Monolithic and Microservice apps .
      </li>

      <li>
        Experience on Java Application development using Java Spring, JSP, Servlets, Swing, Restful
        services, XML, PostgreSQL
      </li>
      <li>Developed modular <b>MFEs</b> using <b>Module Federation</b></li>
      <li>Experience in creating and managing deployment pipelines</li>
      <li>Experience in developing SSO Applications Using Node.js.</li>
      <li>Experience in developing <b>Restful services</b> and <b>GraphQL API</b> using Node.js.</li>
      <li>Experience in developing Restful services using Spring Boot.</li>
      <li>
        Experience in developing <b>Microservices</b> using Seneca Microservice
        framework in Node.js.
      </li>
    </ul>
    <h3>Tutoring</h3>
    <ul>
      <li>Java</li>
      <li>Javascript</li>
      <li>Node.js</li>
      <li>Angular</li>
      <li>React.js</li>
      <li>MongoDB</li>
      <li>OOAD and Design Patterns</li>
    </ul>
    <p></p>
  </p-card>

  <p-card class="p-col-6" styleClass="card-container">
      <div class="dropdown">
    <button class="dropbtn">My Apps ▼</button>

    <div class="dropdown-content">
      
      <a href="https://vplaylearn.vishwanathph.in/" target="_blank">vPlayLearn</a>
    </div>
  </div>
    <h3>Skill chart</h3>
    <app-skill-chart></app-skill-chart>

    <h3>Skill Table</h3>
    <app-skill-table></app-skill-table>
    <app-quotation-notice-board></app-quotation-notice-board>
    <!-- <section class="notice">
    To all trainees , Please mail me personally to "vishwanathph@gmail.com" for any doubts in training sessions
    </section> -->
  </p-card>
</div>